import {
 Component,
 Inject,
 Input,
 PLATFORM_ID,
 ViewChild,
 afterNextRender,
 computed,
 inject,
 signal,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { BannersSkeletonComponent } from '../../../../../skeletons/banners-skeleton/banners-skeleton.component';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
 selector: 'iho-primary-banner',
 standalone: true,
 imports: [CommonModule, SharedModule],
 templateUrl: './primary-banner.component.html',
 styleUrls: ['./primary-banner.component.scss'],
})
export class PrimaryBannerComponent {
 @Input() dataSource: any; //TODO remove this any
 @Input() showBigBanner = true;
 sliderBannerConfig!: any;
 secondaryBannersConfig!: any;
 navigatorVal: any;
 resetSwiper = signal(true);
 cdnUrl = cdnUrl;
 searchBoxService = inject(SearchBoxService);
 accommodation = computed(() => this.searchBoxService.accommodation());

 constructor(
  private swiperService: SwiperService,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  afterNextRender(() => {
   this.resetSwiper.set(false);
   setTimeout(() => this.resetSwiper.set(true), 0);
  });
 }

 ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
   this.navigatorVal = /Android|iPhone/.test(window.navigator.userAgent);
  }

  let swiperConfig = {
   autoplay: {
    delay: 2000,
   },
   slide: this.navigatorVal ? 1 : 2,
   height: 331,
   loop: true,
  };

  this.secondaryBannersConfig = this.swiperService.SwiperConfig(swiperConfig);
  this.sliderBannerConfig = this.swiperService.SwiperConfig({
   ...swiperConfig,
   slide: 1,
  });
 }
}
